import { Address } from "api/graphql/generated";

export const formatAddressLongName = (address?: Address | null): string =>
  address
    ? [[address.address_1, address.address_2].filter(Boolean).join(" "), address.city, address.province_code]
        .filter(Boolean)
        .join(", ")
    : "";
